import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import { Input, Select, InputNumber, DatePicker, Space } from 'antd';
import FormItem from "components/fields/FormItem";
import TextAreaField from "components/fields/TextAreaField";
import SwitchField from "components/fields/SwitchField";
import { requiredField } from '../../../../utils/crudSagaHelper';
import { renderLabel, displayFullName, displayFarmNameLocation } from '../../../../utils/index';
import SelectSearchField from 'components/fields/SelectSearchField';
import { getUserFarmers, getUserFarms } from '../../../../redux/dynamiclist/dynamicListState';
import { DATE_FORMAT } from '../../../../variables/constants';

const RegisterAnimalFields = ({recordData, mode, form, isAdmin=false, 
	requestingFarmerList, farmerList, doGetUserFarmers, userFarmList, requestingUserFarmList, doGetUserFarms, ...props}) => {

	const [animalTypes, setAnimalTypes] = useState([]);
	const [disableHeadcount, setDisableHeadcount] = useState(false);
	
	const doFilterAnimalTypeOption = (category) =>{
		form.setFieldsValue({type_id: null});
		const filteredTypes = recordData?.animalTypeOptions?.filter((data) => data.category === category);
		setAnimalTypes(filteredTypes);		
	}

	useEffect(() => {
		if(recordData){
			setDisableHeadcount(recordData.id > 0);
			doFilterAnimalTypeOption(recordData.category_id);
			
			if(isAdmin){
				if(recordData.user_details_id){
					doGetUserFarmers({user_details_id:recordData.user_details_id, asOptions: 1, user_type: 3});
					doGetUserFarms({user_details_id:recordData.user_details_id, asOptions: 1});
				}
			}			
		}
	}, [recordData]);

	const onCategoryChangeHandler = (value) => {
		doFilterAnimalTypeOption(value);
    };

	const doUserFarmerSearch = (value) =>{
		doGetUserFarmers({keyword:value, asOptions: 1, user_type: 3});
	}

	const handleFarmerChange = (value) =>{
		form.setFieldsValue({farm_id: null});
		doGetUserFarms({user_details_id:value, asOptions: 1});
	}

	const handleChangePerCage = (checked) => {	
		recordData?.id > 0 && setDisableHeadcount(!checked);        
    };

  	return (
    	<>
			<FormItem name="id" hidden>
				<Input type="hidden"/>
			</FormItem>

			{!isAdmin && 
			<FormItem name="user_details_id" hidden>
				<Input type="hidden"/>
			</FormItem>
			}

			<div className="form-column-4">
				{isAdmin && 
				<div className="col-span-4 form-column-4">
					<FormItem extra="col-span-2"
						name="user_details_id"
						label="Farmer"
						rules={[requiredField()]}
						>
							{(mode === 'edit' && recordData?.id === 0) ?
							<SelectSearchField								
								debounceTimeout="1000"
								options={farmerList}
								fetchOptions={doUserFarmerSearch}
								fetching={requestingFarmerList}
								onChange={handleFarmerChange}/>							
							: renderLabel(displayFullName(recordData?.user_details))
							}	
					</FormItem>
				</div>
				}
				<FormItem extra="col-span-1 md:col-span-2"
					name="farm_id"
					label="Farm Name or Location"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<Select id="farm_id"
						allowClear={true}
						showSearch
						options={isAdmin ? userFarmList : recordData?.userFarmParcels}
					/>	
					: renderLabel(displayFarmNameLocation(recordData?.farm))
					}					
				</FormItem>
				<FormItem 
					name="category_id"
					label="Category"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<Select id="category_id"
						allowClear={true}
						options={recordData?.animalCategoryOptions}
						onChange={onCategoryChangeHandler}
					/>					
					: renderLabel(recordData?.category?.name)
					}                
				</FormItem>
				<FormItem 
					name="type_id"
					label="Type"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<Select id="type_id"
						allowClear={true}
						options={animalTypes}
					/>					
					: renderLabel(recordData?.type?.name)
					}                
				</FormItem>	

					<Space>
						<FormItem 
							name="headcount"
							label="Headcount"
							rules={[requiredField()]}
						>
							{mode === 'edit' ?						
							<InputNumber id="headcount" min={1} disabled={disableHeadcount}/>
							: renderLabel(recordData?.headcount)
							}	                
						</FormItem>
						<FormItem 
							name="unit_count"
							label=" "
						>						
							<SwitchField id="unit_count" type="text" 
								disabled={mode !== 'edit'} 
								labelYes="per cage"
								labelNo="per head"
								onChange={handleChangePerCage}/>
						</FormItem>
					</Space>
				<FormItem 
					name="condition_id"
					label="Condition"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<Select id="condition_id"
						allowClear={true}
						options={recordData?.animalConditionOptions}
					/>					
					: renderLabel(recordData?.condition?.name)
					}	                
				</FormItem>
				<FormItem 
					name="purpose_id"
					label="Purpose"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<Select id="purpose_id"
						allowClear={true}
						options={recordData?.animalPurposeOptions}
					/>					
					: renderLabel(recordData?.purpose?.name)
					}	                
				</FormItem>	
				<FormItem 
					name="breed"
					label="Breed"
				>
					{mode === 'edit' ?
					<Input id="breed"
						maxLength={100}		            		
					/>						
					: renderLabel(recordData?.breed)
					}                
				</FormItem>
				<FormItem 
					name="tag_number"
					label="Tag Number"
				>
					{mode === 'edit' ?
					<Input id="tag_number"
						maxLength={30}		            		
					/>						
					: renderLabel(recordData?.tag_number)
					}                
				</FormItem>

				<FormItem 
					name="birthdate"
					label="Estimated Birthdate"
				>
					{mode === 'edit' ?
					<DatePicker id="birthdate"
						format={DATE_FORMAT}
					/>					
					: renderLabel(recordData?.birthdate)
					}                
				</FormItem>
				
				<FormItem extra="col-span-1 md:col-span-3 xl:col-span-4"
					name="remarks"
					label="Notes or Remarks"
				>
					{mode === 'edit' ?
					<TextAreaField id="remarks"
						maxLength={1000}
					/>	
					: renderLabel(recordData?.remarks)
					}					
				</FormItem>
			</div>
	 	</>
  	);
};

const mapStateToProps = (state) => ({
	farmerList: state.dynamicList.userFarmers?.items,
	requestingFarmerList: state.dynamicList.userFarmers?.requesting,
	userFarmList: state.dynamicList.userFarms?.items,
	requestingUserFarmList: state.dynamicList.userFarms?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	doGetUserFarmers: (filters) => dispatch(getUserFarmers(filters)),
	doGetUserFarms: (filters) => dispatch(getUserFarms(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterAnimalFields);
